import React, { useState } from 'react';
import Trans from 'next-translate/Trans';
import Dropzone from 'react-dropzone';

import { FileIcon, Delete } from '@/icons/index';

import styles from './AttachFiles.module.scss';

function AttachFiles({ setFiles, htmlText, onClearFiles }) {
  const [acceptedFiles, setAcceptedFiles] = useState([]);

  const handleDropAccepted = (files) => {
    setAcceptedFiles(files);
    setFiles(files);
  };

  const handleDeleteFile = () => {
    setAcceptedFiles([]);
    setFiles([]);
  };

  return (
    <Dropzone
      accept={{
        'application/pdf': ['.pdf', '.doc', '.docx'],
      }}
      noKeyboard
      maxSize={1.875e6}
      onDropAccepted={handleDropAccepted}
      data-testid='dropzone'
    >
      {({ getRootProps, getInputProps }) => {
        const hasFiles = acceptedFiles.length > 0;
        const fileName = hasFiles ? acceptedFiles[0].name : null;

        return (
          <div
            className='container'
            itemScope
            itemType='https://schema.org/DigitalDocument'
          >
            <div {...getRootProps({ className: styles.dropzone })}>
              <input aria-label='Bakcell' {...getInputProps()} />
              <div>
                {hasFiles ? (
                  <Delete onClick={handleDeleteFile} />
                ) : (
                  <FileIcon />
                )}
              </div>
              <div className={styles.content}>
                <div
                  className={styles.text}
                  dangerouslySetInnerHTML={{
                    __html: hasFiles ? fileName : htmlText,
                  }}
                />
                {!hasFiles && (
                  <span className={styles.desc}>
                    <Trans i18nKey={'common:File size'} />
                  </span>
                )}
                {onClearFiles?.length > 0 && (
                  <ul className={styles.files}>
                    {acceptedFiles.map((file) => (
                      <li key={file.path}>{file.path}</li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>
        );
      }}
    </Dropzone>
  );
}

export default AttachFiles;
